import { isNil } from 'lodash';
import { OwnProps } from '~/types/ownProps';

function meetsDataDependencies(props: OwnProps) {
  const {
    application: { hasAuto, vehicles },
    primaryHomeApplicant,
    primaryAutoApplicant,
    currentProperty: { address },
  } = props;

  if (isNil(address)) {
    return false;
  }

  if (hasAuto) {
    return !!primaryAutoApplicant && vehicles?.length > 0;
  }

  return !!primaryHomeApplicant;
}

const step = {
  route: '/homeowners-insurance/quotes/contact-info',
  isAccessible: () => true,
  breadcrumbStep: 'auto',
  meetsDataDependencies,
};

export default step;
